import { createSlice } from '@reduxjs/toolkit';
import { getURL } from 'helpers/routeHelper';
import { hasValue } from 'swipeclock-frontend';
import { v4 as uuidv4 } from 'uuid';

export function getWebclockContent(anchor) {
  return async (dispatch, getState) => {
    const { token } = await getState().user;
    const { route, target } = anchor;
    const src = getURL({ token, anchor });
    const { url } = src;
    const id = hasValue(route)
      ? `${route}-${uuidv4()}`
      : `component-${uuidv4()}`;
    const content = {
      id,
      src: url,
      target: target,
      route: route,
    };

    dispatch(setWebclockContent(content));
  };
}

export function getWebaccessContent(anchor) {
  return async (dispatch, getState) => {
    const { token } = await getState().user;
    const { route, target } = anchor;
    const src = getURL({ token, anchor });
    const { url } = src;
    const id = hasValue(route)
      ? `${route}-${uuidv4()}`
      : `component-${uuidv4()}`;
    const content = {
      id,
      src: url,
      target: target,
      route: route,
    };

    dispatch(setWebaccessContent(content));
  };
}

export function getLinksAndDocsContent(anchor) {
  return async (dispatch, getState) => {
    const { token } = await getState().user;
    const { route, target } = anchor;
    const src = getURL({ token, anchor });
    const { url } = src;
    const id = hasValue(route)
      ? `${route}-${uuidv4()}`
      : `component-${uuidv4()}`;
    const content = {
      id,
      src: url,
      target: target,
      route: route,
    };

    dispatch(setLinksAndDocsContent(content));
  };
}

export function getZayZoonContent(anchor) {
  return async (dispatch, getState) => {
    const { token } = await getState().user;
    const { route, target, id: zayZoonId } = anchor;
    const src = getURL({ token, anchor });
    const { url } = src;
    const id = hasValue(zayZoonId)
      ? `${zayZoonId}-${uuidv4()}`
      : hasValue(route)
      ? `${route}-${uuidv4()}`
      : `component-${uuidv4()}`;
    const content = {
      id,
      src: url,
      target: target,
      route: route,
    };

    dispatch(setZayZoonContent(content));
  };
}

const slice = createSlice({
  name: 'dashboard',
  initialState: {
    webclockContent: {
      id: null,
      src: null,
      scrolling: 'yes',
    },
    webaccessContent: {
      id: null,
      src: null,
      scrolling: 'no',
    },
    linksAndDocsContent: {
      id: null,
      src: null,
      scrolling: 'no',
    },
    zayZoonContent: {
      id: null,
      src: null,
      scrolling: 'no',
    },
    linksAndDocsRefreshNeeded: false,
  },
  reducers: {
    setWebclockContent(state, action) {
      state.webclockContent = {
        ...state.webclockContent,
        ...action.payload,
      };
    },
    setWebaccessContent(state, action) {
      state.webaccessContent = {
        ...state.webaccessContent,
        ...action.payload,
      };
    },
    setLinksAndDocsContent(state, action) {
      state.linksAndDocsContent = {
        ...state.linksAndDocsContent,
        ...action.payload,
      };
    },
    setLinksAndDocsRefreshNeededStart(state) {
      state.linksAndDocsRefreshNeeded = true;
    },
    setLinksAndDocsRefreshNeededCompleted(state) {
      state.linksAndDocsRefreshNeeded = false;
    },
    setZayZoonContent(state, action) {
      state.zayZoonContent = {
        ...state.zayZoonContent,
        ...action.payload,
      };
    },
  },
});

export const {
  setWebclockContent,
  setWebaccessContent,
  setLinksAndDocsContent,
  setLinksAndDocsRefreshNeededStart,
  setLinksAndDocsRefreshNeededCompleted,
  setZayZoonContent,
} = slice.actions;

export default slice.reducer;
